import { render, staticRenderFns } from "./desktopInfoCard.vue?vue&type=template&id=b5dfd99c&scoped=true&"
import script from "./desktopInfoCard.vue?vue&type=script&lang=js&"
export * from "./desktopInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dfd99c",
  null
  
)

export default component.exports